
const action = function(api) {
    let apiRoot = process.env.API_ROOT;
    return `${apiRoot}${api}`;
}

export const api_video = action('/video/listVideo'); //视频资料-查询所有
export const api_addApplicant = action('/applicant/addApplicant'); //应聘管理-申请加入
export const api_findPrice = action('/price/findPrice'); //查询原子币价格
export const api_listAboutUs = action('/aboutUs/listAboutUs'); //关于我们-查询所有
export const api_listTeamMembers = action('/teamMembers/listTeamMembers'); //团队成员-查询所有
export const api_listCommonProblem = action('/commonProblem/listCommonProblem'); //常见问题-查询所有
export const api_listAudio = action('/audio/listAudio'); //音频资料-查询所有
export const api_listCulture = action('/cultureFolder/listCultureFolder'); //企业文化-查询所有
export const api_listNews = action('/news/listNews'); //新闻资讯-查询所有



// WEBPACK FOOTER //
// ./src/components/APIKeys.js